import React from "react";
import "./RegistrationOptionsPage.scss";
import { Content, Link, usePathFactory, useTranslator } from "@sia/style-guide";
import { useHistory } from "react-router-dom";
import Page from "../../../Page";
import OptionTiles from "./OptionTiles";
const RegisterationMemberOptionsPage = () => {
  const translate = useTranslator();
  const pathFactory = usePathFactory();
  const history = useHistory();
  const options = [
    {
      title: translate("wizard.registeration-options.junior"),
      description: null,
      onClick: () => history.push(pathFactory.create("wizard/register/junior")),
    },
    {
      title: translate("wizard.registeration-options.individual"),
      description: null,
      onClick: () => history.push(pathFactory.create("wizard/register/single")),
    },
    {
      title: translate("wizard.registeration-options.student"),
      description: null,
      onClick: () => history.push(pathFactory.create("wizard/register/student")),
    },
    {
      title: translate("wizard.registeration-options.corporate"),
      description: null,
      onClick: () => history.push(pathFactory.create("wizard/register/corporate")),
    },
  ];
  return (
    <Page>
      <Content centeredTexts={true}>
        <div className="registration-options">
          <h1 className="productive-heading-04 sia-text-12">{translate("wizard.sia-ways.title")}</h1>
          <p className="registration-options__info sia-margin-02-bottom">{translate("wizard.registeration-options.info")}</p>
          <div className="registration-options__link">
            <Link withIcon={true} target={"#"} className={"sia-margin-03-bottom"}>
              {translate("wizard.registeration-options.info.link.label")}
            </Link>
          </div>
          <OptionTiles options={options} />
        </div>
      </Content>
    </Page>
  );
};

export default RegisterationMemberOptionsPage;
